export const Select = ({ array, idPregunta, handleHiddenQ, subpreguntaid }) => {
  const options = array.map((option) => (
    <option key={option.RespuestaId} id={option.RespuestaId} name={idPregunta} 
    subpreguntaid={option.RespuestaTexto == 'Otros' ? subpreguntaid : 0}>
      {option.RespuestaTexto}
    </option>
  ));
  return (
    <select id="select" name={idPregunta} onChange={handleHiddenQ}>
      <option name={idPregunta} defaultValue>
        Elige una opción
      </option>
      {options}
    </select>
  );
};
